export var RolloutStrategyFieldType;
(function (RolloutStrategyFieldType) {
    RolloutStrategyFieldType["String"] = "STRING";
    RolloutStrategyFieldType["SemanticVersion"] = "SEMANTIC_VERSION";
    RolloutStrategyFieldType["Number"] = "NUMBER";
    RolloutStrategyFieldType["Date"] = "DATE";
    RolloutStrategyFieldType["Datetime"] = "DATETIME";
    RolloutStrategyFieldType["Boolean"] = "BOOLEAN";
    RolloutStrategyFieldType["IpAddress"] = "IP_ADDRESS";
})(RolloutStrategyFieldType || (RolloutStrategyFieldType = {}));
//# sourceMappingURL=rollout-strategy-field-type.js.map